import { createRequestTypes } from './utils';
import { buildApiAction } from '../service/oms';

export const NEW = '@@funds/NEW';
export const UPDATE = '@@funds/UPDATE';
export const LOADING = '@@funds/LOADING';
export const FETCH_DATA = createRequestTypes('@@funds/FETCH_DATA');
export const CHANGE_FILTERS = '@@funds/CHANGE_FILTERS';

export function fetchFunds(endpoint, params) {
    const meta = { params };

    return buildApiAction({
        endpoint,
        types: [
            { type: FETCH_DATA.REQUEST, meta },
            {
                type: FETCH_DATA.SUCCESS,
                payload: (action, state, response) => {
                    const contentType = response.headers.get('Content-Type');

                    if (contentType && ~contentType.indexOf('json')) {
                        return response.json().then(json => json.rows || []);
                    }

                    return [];
                },
                meta,
            },
            { type: FETCH_DATA.FAILURE, meta },
        ],
    });
}

export function newFunds(payload) {
    return { type: NEW, payload };
}

export function updateFund(key, data) {
    return { type: UPDATE, key, data };
}

export function loadingFunds() {
    return { type: LOADING };
}

export function changeFundsFilters(filters) {
    return { type: CHANGE_FILTERS, filters };
}



/** WEBPACK FOOTER **
 ** /src/shared/actions/funds.js
 **/